export const getPath = (path, tagSlug) => {
  return path.replace(':tagSlug', tagSlug);
};
